import script from "./client-list-skeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./client-list-skeleton.vue?vue&type=script&setup=true&lang=ts"

import "./client-list-skeleton.vue?vue&type=style&index=0&id=423a03f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423a03f0"]])

export default __exports__